/* GASSISA
=========================================================================================
* Descripcion: Version portatil del entrenamiento IA movil.
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revision   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 26/06/2026 | Lic. Jose Luis Aragon Cervantes  | Creacion de version portatil responsiva
* ---------------------------------------------------------------------------------------
*/

import FrmEntrenamientoIAMovil from "../../../ia/EntrenamientoMovil/FrmEntrenamientoIAMovil.jsx";
import SizeSoftXFrmPortatil from "../../leyout/SizeSoftXFrmPortatil.jsx";

export default function FrmEntrenamientoIAMovilPortatil() {
  return (
    <SizeSoftXFrmPortatil nombreFormulario="FrmEntrenamientoIAMovil">
      <FrmEntrenamientoIAMovil />
    </SizeSoftXFrmPortatil>
  );
}
